export class NotificationPolicyConfigServiceNow {
    'instanceUrl';
    'username';
    'password';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceUrl",
            "baseName": "instanceUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "username",
            "baseName": "username",
            "type": "string",
            "format": ""
        },
        {
            "name": "password",
            "baseName": "password",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationPolicyConfigServiceNow.attributeTypeMap;
    }
    constructor() {
    }
}
